import src from "IMAGE";
export default { src, width: 219, height: 125, blurWidth: 0, blurHeight: 0};
